<body class="newhome-page special-content">
  <div class="container pb-6">
    <div class="croddiffSection container">
      <h4 class="croddiffHeading">{{ '#seychellesislands to be featured (@visitseychelles)' | translate }}</h4>
      <div class="one" #one></div>
    </div>
  </div>
</body>
